const passkey_sign_in = {
    setup_page: {
        title: 'Oturum açmayı kolaylaştır',
        subtitle: 'Geçiş anahtarı oluştur',
        description: 'Geçiş anahtarını cihaz biyometrisi, YubiKey gibi güvenlik anahtarları veya diğer kullanılabilir yöntemlerle kaydet.',
    },
    trigger_conditional_ui_failed: 'Passkey otomatik doldurma tetiklenemedi.',
};
export default Object.freeze(passkey_sign_in);
